var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"active-color",attrs:{"width":_vm.width,"min-width":"120","rounded":"","height":_vm.height,"dark":"","disabled":_vm.disabled},on:{"click":_vm.onPress}},[_c('span',{staticClass:"bold text-uppercase px-5",staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }